const  reviewReducer = (state = {}, action) => {
    switch (action.type) {
      case "ACCEPTED_REVIEW": {
        return{
          ...state,
          reviewSuccess: action.success
        }
      }
      case "ACCEPTED_REVIEW_ERR": {
        return{
          ...state,
          reviewError: action.err
        }
      }
      default:
        return state;
    }
  };
  
  export default reviewReducer;
  